<template>
  <HeadingLv1 text="会員退会手続き" />
  <div class="u-containar">
    <div style="margin-bottom:30px;">
    {{ $store.state.userInfo.name_sei }} さん(会員ID:{{ $store.state.userInfo.system_id }})の、マイナビRESIDENTからの退会手続きを行います。<br>
    一度退会されると、登録情報を再度利用することはできなくなります。<br>
    退会を希望される方は「確認」ボタンを、退会しない方は「戻る」ボタンをクリックしてください。<br>
    </div>
    <form v-on:submit="$router.push('/mypage/leave/confirm')">
    <FormSelectField
      name="school_id"
      label="退会理由をお聞かせください"
      :items="reasons"
      @change-message="updateAnswer($event)"
      req
    />

    <div class="buttons">
      <Button
        label="戻る"
        :handleClick="
          () => {
            this.$router.go(-1)
          }
        "
      />
      <Button
        label="確認する"
        :handleClick="confirm"
        :disabled="isDisabledNextBtn"
        primary
      />
    </div>
    </form>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, computed } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'MypageLeaveInput',

  props: {
    answer: Number,
    answer_comment: String
  },

  components: {
    Button,
    HeadingLv1,
  },
  setup(props: any, context: any) {

    const store = useStore()
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    interface SelectObject {
      label: string,
      value: string,
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '0',
      selected: false
    }

    const reasons: Array<SelectObject> = reactive([selectDefault])

    const select = reactive({
      value : 0
    })

    const confirm = () => {
      router.push('/mypage/leave/confirm');
    }

    const updateAnswer = ($event:any) => {
      context.emit('update:answer', $event)
      context.emit('update:answer_comment', reasons[$event].label)
      select.value = $event
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      getList
        .get('/api/v1/user_leave/unsub_reason')
        .then((res) => {
          res.data.forEach((el: any) => {
            if (el.opt_id != 0) {
              const item: SelectObject = {
                label: el.option_name,
                value: el.opt_id,
                selected: false,
              }
              reasons.push(item)
            }
          })
        })
        .catch(() => {
          state.isLoading = false
        })
    })

    const isDisabledNextBtn = computed(() => {
      console.log("computed", select.value);
      if (select.value >= 1) {
        return false;
      }
      return true;
      /*if (
        (this.a == null || this.a == 0)
      ) {
        return true
      }

      return false*/
    })

    return {
      state,
      FormSelectField,
      confirm,
      reasons,
      updateAnswer,
      isDisabledNextBtn
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.reqBtn {
  @include mixins.media() {
    .button {
      margin-right: 0;
    }
  }
}

::v-deep(.headingLv2) {
  margin-top: 50px;
  margin-bottom: 35px;

  & + .button {
    max-width: 88%;
  }
}

.fixedArea {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  z-index: 100;
  height: 72px;
  background: #fff;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fixedArea .button {
  margin-left: 8px;
  margin-right: 8px;
  max-width: 224px;

  &:first-child {
    flex-shrink: 2;
  }

  &:last-child {
    flex-grow: 1;
  }
}

// ::v-deep(.goalButtons) {
//   position: fixed;
//   bottom: 55px;
//   width: 100%;
//   padding-right: 15px;
//   padding-left: 15px;
//   background: #fff;
//   z-index: 100;
// }

// .fixedArea

// ::v-deep(.goalButtons .button) {
//   max-width: none;
//   flex-basis: 85px;
//   flex-grow: 0;
//   width: auto;
// }

// ::v-deep(.goalButtons .button.primary) {
//   flex-grow: 1;
// }
.buttons {
  display: flex;
  justify-content: center;
  margin: 45px -16px 0;
  padding: 10px 8px;
  background-color: #f5f5f5;

  @include mixins.media() {
    margin: 70px 0 0;
    background-color: transparent;
  }

  .button {
    margin: 0 4px;

    @include mixins.media() {
      margin: 0 8px;
    }
  }
}
</style>
